export async function logError(error: unknown): Promise<void> {
  if (error instanceof Response) {
    try {
      const jsonError = await error.json();
      console.error(jsonError);
      return;
    } catch {
      console.error(error);
      return;
    }
  }

  if (typeof error === 'object' && 'error' in error) {
    console.error(error.error);
    return;
  }

  console.error(error);
}
